import { createTheme, ThemeProvider } from "@material-ui/core/styles";
import { BrowserRouter, Route, Switch } from "react-router-dom";
import ScrollToTop from "./actions/ScrollToTop";
import SwiftFoot from "./components/SwiftFoot";
import SwiftNav from "./components/SwiftNav";
import Whatsapp from "./components/Whatsapp";
import "./css/main.css";
import CoverPage from "./pages/CoverPage";
import Helphome from "./pages/Helphome";
import HelpOptions from "./pages/HelpOptions";
import HelpOptionsStudent from "./pages/HelpOptionsStudent";
import HelpTopics from "./pages/HelpTopics";
import Questions from "./pages/Questions";
import Videos from "./pages/Videos";
import Webinar from "./pages/Webinar";
import { HelmetProvider } from "react-helmet-async";
import { useEffect, useRef, useState } from "react";
import { Button, responsiveFontSizes } from "@material-ui/core";
import NoPage from "./pages/NoPage";
import Facebook from "./components/Facebook";

let theme = createTheme({
  typography: {
    fontFamily: '"Manrope", "Helvetica Nue", "Arial", "Gordita Regular"',
    h4: {
      margin: "20px 0px",
      fontWeight: "600",
    },
    h5: {
      margin: "20px 0px",
      fontWeight: "600",
    },
    h6: {
      margin: "20px 0px",
      marginTop: "40px",
      fontWeight: "600",
    },
    subtitle1: {
      fontWeight: "600",
      [`@media screen and (max-width: 1200px)`]: {
        fontSize: "0.9rem",
      },
    },
    subtitle2: {
      fontWeight: "600",
      [`@media screen and (max-width: 1200px)`]: {
        fontSize: "0.8rem",
      },
    },
  },
});

theme = responsiveFontSizes(theme);

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter>
        <ScrollToTop />
        <ThemeProvider theme={theme}>
          <Switch>
            <Route path="/" exact component={CoverPage} />
            <Route path="*">
              <SwiftNav />
              <div style={{ paddingTop: "70px", minHeight: "100vh" }}>
                <Switch>
                  <Route path="/classic" exact component={Helphome} />
                  <Route path="/webinar" exact component={Webinar} />
                  <Route path="/questions" component={Questions} />
                  <Route path="/help-options" component={HelpOptions} />
                  <Route
                    path="/student-help"
                    component={HelpOptionsStudent}
                  />
                  <Route path="/help-topics" component={HelpTopics} />
                  <Route path="/videos" component={Videos} />
                  <Route path="*" component={NoPage} />
                </Switch>
              </div>
              <SwiftFoot />
              <Whatsapp />
              <Facebook />
            </Route>
          </Switch>
        </ThemeProvider>
      </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
